import {
  BooleanField,
  Show,
  TextField,
  SimpleShowLayout,
  NumberField,
} from "react-admin";
import { LocationButton } from "../location/locationButton";

export const PharmacyShow = (props) => {
  return (
    <Show {...props}>
      <SimpleShowLayout>
        <TextField source="name" />
        <TextField source="vicinity" />
        <NumberField source="rating" />
        <TextField source="website" />
        <TextField source="formattedPhoneNumber" />
        <LocationButton />
      </SimpleShowLayout>
    </Show>
  );
};
